//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
      events: [],
      mode: 'matches',
      outright: null,
      breadcrumbs: null,
      crumbs: null,
      outright_region_slug: null,
      outright_competition_slug: null,
      loading: true,
      competition_slug: '',
      sport_slug: '',
      showTooltip: false,
      competition_info: null
    }
  },
  computed: {
    sports() {
      return this.$store.state.sports
    },
    sport() {
      return _.find(_.values(this.$store.state.sports), { slug: this.$route.params.sport })
    },
    seguro_combinada_config() {
      return this.$store.getters.seguroCombinadaConfig
    },
    seguro_combinada_scopes() {
      const sportConfigs = _.get(this.seguro_combinada_config, 'sport_configs', [])
      return _.flatMap(sportConfigs, (sc) => sc.config || [])
    },
    seguroCombinadaEligible() {
      if (!this.seguro_combinada_config || !this.competition_slug) return false

      const providerCompetitionId = parseInt(_.get(this.competition_info, 'competition_id'))
      const sportSlug = _.get(this.competition_info, 'sport_slug')

      return this.seguro_combinada_scopes.some((scope) => {
        if (scope.sport_id && String(scope.sport_id).toLowerCase() !== String(sportSlug).toLowerCase()) return false
        if (scope.provider_competition_id && scope.provider_competition_id !== providerCompetitionId) return false
        return true
      })
    }
  },
  mounted() {
    this.fetchEvents()
    this._onDocumentClick = (event) => {
      if (!this.showTooltip) return
      const wrapper = this.$refs.seguroWrapper
      if (wrapper && !wrapper.contains(event.target)) {
        this.showTooltip = false
      }
    }
    document.addEventListener('click', this._onDocumentClick)
    this.fetchInfo()
  },
  beforeDestroy() {
    document.removeEventListener('click', this._onDocumentClick)
  },
  async fetch() {
      try {
        let params = this.$route.params;
        params['lang'] = this.lang;
        const response = await this.$content().get('breadcrumbs', { params: params })

        if(_.get(response.data.data, 'competition') == null){
          this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
        }

        this.breadcrumbs = _.get(response.data.data, 'region.name') + ' ' + _.get(response.data.data, 'competition.name')
        this.crumbs = [
          {'name' : _.get(response.data.data, 'sport.name'), 'url': this.localePath('/' + _.get(response.data.data, 'sport.translated_slug')) },
        ]
        this.$store.commit('seo/setVariables', {
          sport: _.get(response.data.data, 'sport.name'),
          region: _.get(response.data.data, 'region.name'),
          competition: _.get(response.data.data, 'competition.name'),
        });
        await this.fetchInfo()
        
        if (this.sport_slug && this.competition_slug) {
          let params_event = {}
          params_event['sport'] = this.sport_slug
          params_event['competition'] = this.competition_slug
          params_event['key'] = 'market_type'
          params_event['lang'] = 'es'
          params_event['bookmaker'] = this.$config.BOOKMAKER

          let resp = await this.$axios.$get(process.env.SPORTSBOOK_API + '/echo/v1/events-simple', {
            timeout: 10000,
            params: params_event
          })

          this.$store.commit('games/setEventsInfo', [_.get(resp, 'competitions.0')]);
        }
        
      } catch (e) {
        console.log(e.message);
      }
  },
  methods: {
    getURL: function (competition, mode) {
      if (mode === 'outrights') {
        return this.localePath({ name: 'sport-competition-outrights', params: { competition: competition.slug } })
      }
      return this.localePath({ name: 'sport-competition', params: { competition: competition.slug } })
    },
    async fetchInfo() {
      let params = this.$route.params;
      params['lang'] = this.lang;
      params['bookmaker'] = process.env.BOOKMAKER;
      const response = await this.$infoapi().get('v1/info/outright', { params: params })
      if (_.get(response, 'data.outright.count') > 0) {
        this.outright = _.get(response, 'data.outright');
        this.outright_region_slug = _.get(response, 'data.outright.region_slug');
        this.outright_competition_slug = _.get(response, 'data.outright.slug');
      }
      if (_.get(response, 'data.competition.count') > 0) {
        this.competition_slug = _.get(response, 'data.competition.slug');
        this.sport_slug = _.get(response, 'data.competition.sport_slug');
        this.competition_info = _.get(response, 'data.competition');
      }
    },
    async fetchEvents() {
      this.loading = true
      this.loading = false
    }
  }
}
